import { ClipService } from '../types';
import { SupabaseClipInstance } from '@/types/clipTypes';

import type { WriteScope } from '@/modules/undoRedo';
export class ClipServiceImpl {
  constructor(private readonly clipService: ClipService) {}

  async fetchClipTypeRow(clipTypeId: string) {
    return this.clipService.fetchClipTypeRow(clipTypeId);
  }

  async fetchAwaitClipType() {
    return this.clipService.fetchAwaitClipType();
  }

  async fetchAllSceneClips(sceneId: string) {
    return this.clipService.fetchAllSceneClips(sceneId);
  }

  async fetchClips() {
    return this.clipService.fetchClips();
  }


  async fetchAnimationClipTypesForAsset(assetTypeId: string | null) {
    return this.clipService.fetchAnimationClipTypesForAsset(assetTypeId);
  }

  async addClipInstanceRow(newClipInstance: SupabaseClipInstance, scope?: WriteScope) {
    return this.clipService.addClipInstanceRow(newClipInstance, scope);
  }

  async deleteClipInstance(clipInstanceId: string, scope?: WriteScope) {
    return this.clipService.deleteClipInstance(clipInstanceId, scope);
  }

  async updateClipInstanceTime(clipInstanceId: string, beginTime: number, endTime: number, speed?: number, scope?: WriteScope) {
    return this.clipService.updateClipInstanceTime(clipInstanceId, beginTime, endTime, speed, scope);
  }

  async updateClipInstanceTimeAndSettings(clipInstanceId: string, beginTime: number, endTime: number, speed: number | undefined, settings: Record<string, unknown>, scope?: WriteScope) {
    return this.clipService.updateClipInstanceTimeAndSettings(clipInstanceId, beginTime, endTime, speed, settings, scope);
  }

  async updateClipInstanceTrigger(clipInstanceId: string, triggerAssetInstanceId: string | null, scope?: WriteScope) {
    return this.clipService.updateClipInstanceTrigger(clipInstanceId, triggerAssetInstanceId, scope);
  }

  async updateClipInstanceUiElement(clipInstanceId: string, uiElementInstanceId: string, scope?: WriteScope) {
    return this.clipService.updateClipInstanceUiElement(clipInstanceId, uiElementInstanceId, scope);
  }

  // New method for updating clip volume
  async updateClipInstanceVolume(clipInstanceId: string, volume: number, scope?: WriteScope) {
    try {
      // ClipAdapter returns the data array directly, not { data, error }
      const data = await this.clipService.updateClipInstanceVolume(clipInstanceId, volume, scope);

      if (!data || data.length === 0) {
        throw new Error('No data returned from volume update operation');
      }

      return data[0];
    } catch (error) {
      console.error('Supabase volume update failed:', {
        clipId: clipInstanceId,
        volume,
        error
      });
      throw error;
    }
  }

  async updateClipInstanceSettings(clipInstanceId: string, settings: any, scope?: WriteScope): Promise<any> {
    return this.clipService.updateClipInstanceSettings(clipInstanceId, settings, scope);
  }

  async updateClipInstanceSpeed(clipInstanceId: string, speed: number, scope?: WriteScope): Promise<any> {
    return this.clipService.updateClipInstanceSpeed(clipInstanceId, speed, scope);
  }

  async updateClipInstanceDisplayName(clipInstanceId: string, displayName: string, scope?: WriteScope): Promise<any> {
    return this.clipService.updateClipInstanceDisplayName(clipInstanceId, displayName, scope);
  }
}